import PropTypes from "prop-types";
function CustomImg(props) {
  const { src, alt, className, hasNote, ...imgProps } = props;
  return (
    <div className="d-inline relative">
      <img src={src} alt={alt} className={className} {...imgProps}/>
      {hasNote && <span className="red-dot"></span>}
    </div>
  );
}

CustomImg.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  className: PropTypes.string,
  hasNote: PropTypes.bool,
};

export default CustomImg;

